import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Heart, ArrowRight, ChartLineUp } from "@phosphor-icons/react";
import api from "@/lib/api";

const BASE = 412000;
const GOAL = 3000000;

export default function MissionProgress() {
  const [raised, setRaised] = useState(BASE);
  const [goal, setGoal] = useState(GOAL);
  const [count, setCount] = useState(null);

  useEffect(() => {
    api.get("/donations/total").then(({ data }) => { setRaised(data.raised); setGoal(data.goal); setCount(data.count); }).catch(() => {});
  }, []);

  const pct = Math.min(100, Math.round((raised / goal) * 100));
  return (
    <section className="max-w-5xl mx-auto px-5 sm:px-8 py-16" data-testid="mission-progress">
      <div className="rounded-2xl border border-primary/30 bg-card p-8 sm:p-10 neon-glow">
        <p className="overline text-primary mb-2 inline-flex items-center gap-2"><Heart weight="fill" size={14} /> The $3M Mission · <span className="text-secondary inline-flex items-center gap-1"><ChartLineUp weight="bold" size={12} /> Live</span></p>
        <h2 className="font-display text-3xl sm:text-4xl mb-3">300 acres. 3,000 pits. <span className="neon-text">One ranch.</span></h2>
        <p className="text-muted-foreground mb-7 max-w-2xl leading-relaxed">Every drop funds the ranch. Here's how close the pack is to bringing them all home{count ? ` — ${count} gifts and climbing` : ""}.</p>
        <div className="flex items-end justify-between mb-3">
          <span className="text-2xl sm:text-3xl font-modern" data-testid="mission-raised">${Number(raised).toLocaleString()}</span>
          <span className="overline text-muted-foreground">of ${Number(goal).toLocaleString()} · {pct}%</span>
        </div>
        <div className="h-4 w-full rounded-full bg-white/10 overflow-hidden">
          <motion.div initial={{ width: 0 }} whileInView={{ width: `${pct}%` }} viewport={{ once: true }} transition={{ duration: 1.3, ease: "easeOut" }}
            className="h-full rounded-full bg-gradient-to-r from-primary to-secondary" data-testid="mission-progress-bar" />
        </div>
        <div className="mt-7">
          <Link to="/donate" className="inline-flex items-center gap-2 bg-primary text-primary-foreground px-6 py-3 rounded-[10px] font-modern font-medium hover:bg-primary/90 transition-colors" data-testid="mission-donate-cta">
            <Heart weight="fill" size={16} /> Donate to Heaven <ArrowRight size={16} />
          </Link>
        </div>
      </div>
    </section>
  );
}
